import type { GenericLanguages } from '@payloadcms/translations'

export const i18n: Partial<GenericLanguages> = {
  ar: { defaultStyle: 'النمط الافتراضي' },
  az: { defaultStyle: 'Defolt üslub' },
  bg: { defaultStyle: 'Стандартен стил' },
  cs: { defaultStyle: 'Výchozí styl' },
  da: { defaultStyle: 'Standardstil' },
  de: { defaultStyle: 'Standardstil' },
  en: { defaultStyle: 'Default style' },
  es: { defaultStyle: 'Estilo predeterminado' },
  et: { defaultStyle: 'Vaikimisi stiil' },
  fa: { defaultStyle: 'سبک پیش‌فرض' },
  fr: { defaultStyle: 'Style par défaut' },
  he: { defaultStyle: 'סגנון ברירת מחדל' },
  hr: { defaultStyle: 'Zadani stil' },
  hu: { defaultStyle: 'Alapértelmezett stílus' },
  is: { defaultStyle: 'Sjálfgefinn stíll' },
  it: { defaultStyle: 'Stile predefinito' },
  ja: { defaultStyle: 'デフォルトスタイル' },
  ko: { defaultStyle: '기본 스타일' },
  my: { defaultStyle: 'Gaya lalai' },
  nb: { defaultStyle: 'Standardstil' },
  nl: { defaultStyle: 'Standaardstijl' },
  pl: { defaultStyle: 'Domyślny styl' },
  pt: { defaultStyle: 'Estilo padrão' },
  ro: { defaultStyle: 'Stil implicit' },
  rs: { defaultStyle: 'Подразумевани стил' },
  'rs-latin': { defaultStyle: 'Podrazumevani stil' },
  ru: { defaultStyle: 'Стиль по умолчанию' },
  sk: { defaultStyle: 'Predvolený štýl' },
  sl: { defaultStyle: 'Privzeti slog' },
  sv: { defaultStyle: 'Standardstil' },
  ta: { defaultStyle: 'பொது பாணி' },
  th: { defaultStyle: 'สไตล์เริ่มต้น' },
  tr: { defaultStyle: 'Varsayılan stil' },
  uk: { defaultStyle: 'Стиль за замовчуванням' },
  vi: { defaultStyle: 'Kiểu mặc định' },
  zh: { defaultStyle: '默认样式' },
  'zh-TW': { defaultStyle: '預設樣式' },
}
